<p-accordion styleClass="cfc-collapse-container">
  <p-accordionTab [(selected)]="isOpenQueryCollapse">
    <div class="cfc-dialog-query-container mb-20">
      <div class="p-grid">
        <div class="p-col-12">
          <div class="p-fluid">
            <div class="p-field">
              <div class="p-field-label">
                <label>{{ "Search.Common.CustomerName" | translate }}</label>
              </div>
            </div>
            <input
              pInputText
              [placeholder]="'Common.FormControl.PleaseInput' | translate"
              [(ngModel)]="queryCustomerOrIdNo"
            />
          </div>
        </div>
      </div>
      <div class="p-grid mt-5">
        <div class="p-col-12">
          <div class="p-fluid">
            <div class="p-field">
              <div class="button button-text-center p-p-0">
                <a
                  class="btn btn-primary text-center p-mr-2"
                  (click)="searchForCustomer()"
                >
                  {{ "Common.Button.Search" | translate }}
                </a>
                <a
                  class="btn btn-secondary text-center"
                  (click)="clearForCustomer()"
                >
                  {{ "Common.Button.Clear" | translate }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </p-accordionTab>
</p-accordion>
<div class="cfc-collapse-toggle-container mt-20 mb-20">
  <hr class="cfc-divider"/>
  <button
    pButton
    [label]="
        isOpenQueryCollapse
          ? ('Common.Button.Collapse' | translate)
          : ('Common.Button.Expand' | translate)
      "
    type="button"
    [icon]="
        isOpenQueryCollapse ? 'pi pi-arrow-up-gold' : 'pi pi-arrow-down-gold'
      "
    iconPos="right"
    class="p-button-outlined cfc-collapse-button mh-10"
    (click)="isOpenQueryCollapse = !isOpenQueryCollapse"
  ></button>
  <hr class="cfc-divider"/>
</div>

<app-mobile-total-records [totalRecords]="queryCustomerRes.length" [showMobileSwitch]="false"></app-mobile-total-records>
<div class="table">
  <p-table
    [value]="queryCustomerRes"
    [paginator]="true"
    [rowsPerPageOptions]="[10, 25, 50, 100]"
    [first]="0"
    [rows]="10"
    [showCurrentPageReport]="true"
    [currentPageReportTemplate]="'SigvLibrary.PaginationInfo' | translate"
    paginatorDropdownAppendTo="body"
  >
    <ng-template pTemplate="header">
      <tr>
        <th>{{ "Search.Common.IdNo" | translate }}</th>
        <th>{{ "Search.Common.CustomerName" | translate }}</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-row let-rowIndex="rowIndex" let-columns="columns">
      <tr class="notExpanded" [ngClass]="{ odd: rowIndex % 2 === 0, even: rowIndex % 2 !== 0 }">
        <td>
          <a href="javascript:void(0)" class="link" (click)="selectedIdNo(row)">
            {{ row.idNo }}
          </a>
        </td>
        <td>{{ row.customerName }}</td>
      </tr>

      <!--手機版 layout -->
      <tr class="isExpanded" [ngClass]="{ odd: rowIndex % 2 === 0, even: rowIndex % 2 !== 0 }">
        <td>
          <div class="p-column-title">{{ "Search.Common.IdNo" | translate }}</div>
          <div class="p-column-content">
            <a href="javascript:void(0)" class="link" (click)="selectedIdNo(row)">
              {{ row.idNo }}
            </a>
          </div>
        </td>
        <td>
          <div class="p-column-title">{{ "Search.Common.CustomerName" | translate }}</div>
          <div class="p-column-content">
            {{ row.customerName }}
          </div>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage" let-columns>
      <tr>
        <td class="p-text-center" [attr.colspan]="2">
          {{ "SigvLibrary.NoData" | translate }}
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="paginatorright">
      {{ "Common.Paginator.RowPerPage" | translate }}
    </ng-template>
  </p-table>
</div>
